import React, { useEffect, useMemo, useRef } from 'react';
import { youtubeAt } from './util';

export default function StageTranscript({ transcript, videoId, highlightTs, cards }) {
  const lines = useMemo(() => (transcript?.text || '').split('\n'), [transcript]);
  const names = useMemo(
    () => (cards || []).map((c) => (c.raw_name || c.web_name || '').toLowerCase()).filter((n) => n.length > 3),
    [cards]
  );
  const ref = useRef(null);

  useEffect(() => {
    if (!highlightTs || !ref.current) return;
    const el = ref.current.querySelector(`[data-ts="${highlightTs}"]`);
    if (el) el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, [highlightTs]);

  if (!transcript) return <p className="text-token-base text-muted-foreground">No transcript yet — run the extract step.</p>;

  const mark = (text) => {
    if (!names.length) return text;
    const re = new RegExp(`(${names.map((n) => n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'ig');
    return text.split(re).map((part, i) =>
      names.includes(part.toLowerCase()) ? <mark key={i} className="rounded bg-warning/30 px-0.5">{part}</mark> : part
    );
  };

  return (
    <div>
      <p className="mb-2 text-token-base text-muted-foreground">
        {transcript.source} · {transcript.track_kind || ''} · {Math.round(transcript.char_count / 1000)}k chars ·{' '}
        {transcript.duration_s ? `${Math.round(transcript.duration_s / 60)} min` : ''}
      </p>
      <div ref={ref} className="max-h-[420px] overflow-y-auto rounded-md border border-borderGrey bg-muted/20 p-3 font-mono text-[12px] leading-5">
        {lines.map((line, i) => {
          const m = line.match(/^\[([\d:]+)\]\s?(.*)$/);
          const ts = m ? `[${m[1]}]` : null;
          const body = m ? m[2] : line;
          const hl = ts && ts === highlightTs;
          return (
            <div key={i} data-ts={ts || undefined} className={hl ? 'rounded bg-brand-purple1/15' : ''}>
              {ts && (
                <a className="mr-2 text-primary" href={youtubeAt(videoId, m[1])} target="_blank" rel="noreferrer">
                  {ts}
                </a>
              )}
              {mark(body)}
            </div>
          );
        })}
      </div>
    </div>
  );
}
